import { useState } from 'react';

import { useAuth } from '@/providers/AuthProvider';

export function OrganizationSwitcher() {
  const { organizations, organization, selectOrganization } = useAuth();
  const [isSelecting, setIsSelecting] = useState(false);

  if (organizations.length === 0) {
    return null;
  }

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setIsSelecting(previous => !previous)}
        className="flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-4 py-2 text-xs text-white hover:bg-white/20"
      >
        <span className="font-semibold">{organization?.name ?? 'Select organization'}</span>
        <span className="text-white/50">▾</span>
      </button>
      {isSelecting ? (
        <div className="absolute right-0 z-20 mt-2 w-56 rounded-2xl border border-white/10 bg-surface-900/95 p-2 text-xs text-white shadow-card">
          {organizations.map(org => (
            <button
              key={org.id}
              type="button"
              onClick={async () => {
                await selectOrganization(org.id);
                setIsSelecting(false);
              }}
              className={`flex w-full flex-col rounded-xl px-3 py-2 text-left hover:bg-white/10 ${org.id === organization?.id ? 'bg-white/10 text-white' : 'text-white/70'}`}
            >
              <span className="font-semibold">{org.name}</span>
              <span className="text-[10px] uppercase tracking-[0.3em] text-white/40">{org.role}</span>
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
